<button
  class="ui-button"
  [attr.data-variant]="variant()"
  [attr.data-size]="size()"
  [attr.aria-label]="ariaLabel() || null"
  [disabled]="disabled()"
  [type]="type()"
  [class.ui-button--full]="fullWidth()"
>
  <span class="ui-button__label">
    <ng-content />
  </span>
  @if (badgeText()) {
    <span class="ui-button__badge">{{ badgeText() }}</span>
  }
</button>
